import { render, staticRenderFns } from "./UnusedFilesPagination.vue?vue&type=template&id=222b2d73"
import script from "./UnusedFilesPagination.vue?vue&type=script&lang=js"
export * from "./UnusedFilesPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports